export default __webpack_public_path__ + "static/media/stateseal.b2e72866.png";